<!-- 个人信息 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 34.76">
    <title>个人信息</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.16" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.16" rx="13.61" ry="6.79" />
        <path class="cls-3" d="M22.31,25.7a12.78,12.78,0,1,1,7.24-7" />
        <circle class="cls-3" cx="17.79" cy="10.42" r="3.92" />
        <path
          class="cls-3"
          d="M13.69,15.52a6,6,0,0,0-2.88,5.05v.14l14-.14c0-3.44-3.13-6.23-7-6.23"
        />
        <circle class="cls-4" cx="27.58" cy="22.61" r="1.36" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 34.8">
    <title>个人信息</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.2" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.2" rx="13.61" ry="6.79" />
        <path class="cls-3" d="M22.31,25.74a12.78,12.78,0,1,1,7.24-7" />
        <circle class="cls-3" cx="17.79" cy="10.47" r="3.92" />
        <path
          class="cls-3"
          d="M13.69,15.56a6.06,6.06,0,0,0-2.88,5.06v.14l14-.14c0-3.45-3.13-6.24-7-6.24"
        />
        <circle class="cls-4" cx="27.58" cy="22.65" r="1.36" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 34.32">
    <title>个人信息</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="25.72" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="25.72" rx="13.61" ry="6.79" />
        <path class="cls-3" d="M22.32,25.61a12.67,12.67,0,1,1,7.19-6.92" />
        <circle class="cls-4" cx="17.84" cy="10.46" r="3.89" />
        <path
          class="cls-5"
          d="M13.78,15.51a6,6,0,0,0-2.87,5,.61.61,0,0,0,0,.14l13.85-.14c0-3.41-3.1-6.18-6.93-6.18"
        />
        <circle class="cls-6" cx="27.79" cy="22.54" r="1.35" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.99px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.07px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
      stroke: #34aa91;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.2px;
    }
    .cls-4 {
      stroke-width: 2.03px;
    }
    .cls-5 {
      stroke-width: 1.89px;
    }
    .cls-6 {
      fill: #34aa91;
    }
  }
</style>
